import sales from '../../../services/sales';
import account from '../../../services/account';
import messageDialog from '../../../components/message-dialog.vue'

export default {
  data() {
    return {
      taxpayerIdNumber: '',
      contactName: '',
      contactEmail: '',
      contactJobTitle: '', //TODO nao tem o campo TEL no SOA
      companyName: '',
      sizeOfFleetVehicle: '',
      formState: 'NEW',
      errorMessage: '',
      loading: undefined,
      leadClient: false
    }
  },
  computed: {

  },
  created() {
    let promo = this.$route.query.oferta;
    
    
    if (promo) {
      window.sessionStorage.setItem('promo', promo);
    }
  },
  mounted() {
    (function ($) {
      $.fn.countTo = function (options) {
        options = options || {};

        return $(this).each(function () {
          // set options for current element
          var settings = $.extend({}, $.fn.countTo.defaults, {
            from: $(this).data('from'),
            to: $(this).data('to'),
            speed: $(this).data('speed'),
            refreshInterval: $(this).data('refresh-interval'),
            decimals: $(this).data('decimals')
          }, options);

          // how many times to update the value, and how much to increment the value on each update
          var loops = Math.ceil(settings.speed / settings.refreshInterval),
            increment = (settings.to - settings.from) / loops;

          // references & variables that will change with each update
          var self = this,
            $self = $(this),
            loopCount = 0,
            value = settings.from,
            data = $self.data('countTo') || {};

          $self.data('countTo', data);

          // if an existing interval can be found, clear it first
          if (data.interval) {
            clearInterval(data.interval);
          }
          data.interval = setInterval(updateTimer, settings.refreshInterval);

          // initialize the element with the starting value
          render(value);

          function updateTimer() {
            value += increment;
            loopCount++;

            render(value);

            if (typeof (settings.onUpdate) == 'function') {
              settings.onUpdate.call(self, value);
            }

            if (loopCount >= loops) {
              // remove the interval
              $self.removeData('countTo');
              clearInterval(data.interval);
              value = settings.to;

              if (typeof (settings.onComplete) == 'function') {
                settings.onComplete.call(self, value);
              }
            }
          }

          function render(value) {
            var formattedValue = settings.formatter.call(self, value, settings);
            $self.html(formattedValue);
          }
        });
      };

      $.fn.countTo.defaults = {
        from: 0, // the number the element should start at
        to: 0, // the number the element should end at
        speed: 1000, // how long it should take to count between the target numbers
        refreshInterval: 100, // how often the element should be updated
        decimals: 0, // the number of decimal places to show
        formatter: formatter, // handler for formatting the value before rendering
        onUpdate: null, // callback method for every time the element is updated
        onComplete: null // callback method for when the element finishes updating
      };

      function formatter(value, settings) {
        return value.toFixed(settings.decimals);
      }
    }(jQuery));

    jQuery(function ($) {
      // custom formatting example
      $('.count-number').data('countToOptions', {
        formatter: function (value, options) {
          return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, '.');
        }
      });

      // start all the timers
      $('.timer').each(count);

      function count(options) {
        var $this = $(this);
        options = $.extend({}, options || {}, $this.data('countToOptions') || {});
        $this.countTo(options);
      }
    });
  },

  methods: {
    scroll() {
      $('html, body').stop().animate({
        scrollTop: $("#form").offset().top - 180
      }, 1000);
    },
    doRequest() {
      let vm = this;
      vm.formState = 'NEW';
      try {

        vm.loading = vm.$validator.validateAll()
          .then(success => {
            let request = {
              lead: {
                taxpayerIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase(),
                contactName: vm.contactName,
                contactEmail: vm.contactEmail,
                phone: vm.contactJobTitle.replace(/[^\d]+/g, ''),
                companyName: vm.companyName,
                sizeOfFleetVehicle: vm.sizeOfFleetVehicle,
                "source": window.document.webview ? "MOBILE" : "WEBSITE",
              }
            };

            let promo = window.sessionStorage.getItem('promo');
            if (promo)
              request.lead.campaign = promo;

            if (this.$route.query.plano)
              request.lead.plan = this.$route.query.plano;

            let taxpayerIdNumber = vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
            let proposal = '';
            let promises = [];
            promises.push(sales.getLead({
              taxpayerIdNumber,
              proposal
            }));
            promises.push(account.accountExists({
              taxIdNumber: vm.taxpayerIdNumber.replace(/[.\-\/]/g, '').toUpperCase()
            }));

            return Promise.all(promises).then(response => {

              


              let statusProposal = ['TRIAGEM', 'PROSPECÇÃO'];


              if (response[0].proposal && statusProposal.includes(response[0].proposal.listProposalStatus[0].status)) {
                vm.formState = 'LEAD-INFO';
                this.leadClient = !response[1];
                return Promise.resolve(true);
              }

              if (response[0].lead && response[0].proposal && response[0].proposal.listProposalStatus[0].status == 'LEAD DESCARTADO') {
                request.lead.leadId = response[0].lead.leadId;

                let promise = [];
                request.createProcess = "";
                promise.push(sales.updateLead(request));
                let leadId = request.lead.leadId;
                promise.push(sales.createANewProposal({
                  leadId
                }));

                return Promise.all(promise).then(response => {
                  
                  vm.formState = 'SUCCESS';
                });
              }


              return sales.createLead(request)
                .then(data => {
                  if (data) vm.formState = 'SUCCESS';
                })
                .catch(err => {
                  vm.formState = 'ERROR';
                  vm.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um erro, por favor tente novamente";
                });
            }).catch(err => {
              
              
            });
          }).catch(err => {
            
            
            vm.formState = 'ERROR';
            vm.errorMessage = 'Campos obrigatórios não foram preenchidos!';
          });
      } catch (e) {
        
        
      }
    },
  },



  components: {}


}



// WEBPACK FOOTER //
// ./src/pages/external/promo/promo-toll-ticket.js